import { IS_SG } from 'common/constants/contstants';
import { getAuthToken, isSystemPage } from 'common/requests';
import { useCurrentContactQuery } from 'graphql/queries/__generated__/currentContact';

/**
 * Providers migrated from EU to the Vietnam ERP must accept SG Terms & NDA
 * before they can access any other page.
 */
export const useSgTermsAcceptance = () => {
  const skip = !IS_SG || isSystemPage() || !getAuthToken();
  const { data, loading } = useCurrentContactQuery({ skip });

  if (skip) {
    return { loading: false, needsSgTermsAcceptance: false };
  }

  const provider = data?.currentContact?.provider;
  const needsSgTermsAcceptance = Boolean(provider?.vietnamMigrationEuErpId) && !provider?.sgTermsAccepted;

  return { loading, needsSgTermsAcceptance };
};
